(function () {
    var TRIGGER_SELECTOR = '.tooltip-trigger';
    var TOOLTIP_SELECTOR = '.tooltip-text';
    var CLOSE_SELECTOR = '.closeTooltip';
    var OPEN_CLASSES = ['is-open', 'open', 'visible', 'show']; // adjust to your CSS

    // Check if an element is visible via classes or computed styles
    // Fix: ensure tooltip icon never gets hidden
    function restoreTooltipIcon(trigger) {
        if (!trigger) return;

        var icon = trigger.querySelector('.tooltip-icon');
        if (icon) {
            icon.style.setProperty('display', 'block', 'important');
            icon.style.setProperty('visibility', 'visible', 'important');
            icon.style.setProperty('opacity', '1', 'important');
        }
    }
    function isVisible(tooltip) {
        if (!tooltip) return false;

        const cs = window.getComputedStyle(tooltip);
        return (
            tooltip.classList.contains('is-open') ||
            cs.display !== 'none'
        );
    }

    // Get tooltip that is the immediate next sibling
    function getTooltipForTrigger(trigger) {
        if (!trigger) return null;
        var sib = trigger.nextElementSibling;
        return (sib && matches(sib, TOOLTIP_SELECTOR)) ? sib : null;
    }

    // Polyfill for Element.matches across browsers
    function matches(el, sel) {
        if (!el || !sel) return false;

        var fn =
            el.matches ||
            el.msMatchesSelector ||
            el.webkitMatchesSelector;

        return fn ? fn.call(el, sel) : false;
    }

    // Ensure tooltip has an ID
    function ensureId(el) {
        if (!el.id) {
            el.id = 'tooltip-' + Math.random().toString(36).slice(2, 9);
        }
        return el.id;
    }

    // Sync aria-describedby based on current visibility
    function syncAria(trigger, tooltip) {

        // ADD THIS
        if (
            !trigger ||
            !tooltip ||
            !trigger.isConnected ||
            !tooltip.isConnected
        ) {
            return;
        }

        var id = tooltip.id || ensureId(tooltip);   // CHANGED

        if (isVisible(tooltip)) {

            // ===== ADDED START =====
            // Re-add aria-describedby after tooltip becomes visible
            trigger.removeAttribute('aria-describedby');

            setTimeout(function () {
                if (trigger.isConnected && tooltip.isConnected && isVisible(tooltip)) {
                    trigger.setAttribute('aria-describedby', id);
                }
            }, 50);
            // ===== ADDED END =====

            if (!tooltip.hasAttribute('role')) {
                tooltip.setAttribute('role', 'tooltip');
            }

        } else {

            if (
                trigger.isConnected &&
                trigger.getAttribute('aria-describedby') === id
            ) {
                trigger.removeAttribute('aria-describedby');
            }
        }
    }


    // Open/close helpers (useful if you toggle by class)
    function openTooltip(trigger, tooltip) {
        if (!tooltip) return;

        tooltip.classList.add(OPEN_CLASS);

        restoreTooltipIcon(trigger);

        // ===== ADDED START =====
        var tooltipId = tooltip.id;

        if (tooltipId) {
            setTimeout(function () {
                if (isVisible(tooltip)) {
                    trigger.removeAttribute('aria-describedby');
                    trigger.setAttribute('aria-describedby', tooltipId);
                }
            }, 50);
        }
        // ===== ADDED END =====

        syncAria(trigger, tooltip);
    }

    function closeTooltip(trigger, tooltip) {
        if (!tooltip) return;
        tooltip.classList.remove(OPEN_CLASS);
        // FIX
        restoreTooltipIcon(trigger);
        trigger.removeAttribute('aria-describedby');

        syncAria(trigger, tooltip);
    }
    // 🔴 ADDED START - Close tooltip when focus leaves tooltip/trigger
    function handleFocusLeave(trigger, tooltip) {
        if (!trigger || !tooltip) return;

        setTimeout(function () {
            var activeEl = document.activeElement;

            var focusStillInsideTrigger =
                trigger.contains(activeEl);

            var focusStillInsideTooltip =
                tooltip.contains(activeEl);

            // 🔴 CHANGED

            if (!focusStillInsideTrigger && !focusStillInsideTooltip) {

                if (hasInteractiveControls(tooltip)) {
                    // allow natural tabbing through controls
                }

                closeTooltip(trigger, tooltip);
                $('.veil').hide();

                if (currentOpenTrigger === trigger) {
                    currentOpenTrigger = null;
                }
            }
        }, 0);
    }
    // 🔴 ADDED END

    // Configure the class you want to toggle
    const OPEN_CLASS = 'is-open';

    var currentOpenTrigger = null; // ADDED

    document.addEventListener('click', function (e) {
        var trigger = e.target.closest ? e.target.closest(TRIGGER_SELECTOR) : null;
        if (trigger) {
            var tooltip = getTooltipForTrigger(trigger);
            if (!tooltip) return;

            if (isVisible(tooltip)) {
                // trigger.classList.remove(OPEN_CLASS);
                closeTooltip(trigger, tooltip);
                $('.veil').hide();
                if (currentOpenTrigger === trigger) currentOpenTrigger = null; // ADDED
            } else {
                // trigger.classList.add(OPEN_CLASS);
                openTooltip(trigger, tooltip);
                $('.veil').show();
                currentOpenTrigger = trigger; // ADDED
            }
            return;
        }

        // Close button inside tooltip
        var closeBtn = e.target.closest ? e.target.closest(CLOSE_SELECTOR) : null;
        if (closeBtn) {
            var tooltipEl = closest(closeBtn, TOOLTIP_SELECTOR);
            var relTrigger = (tooltipEl && tooltipEl.previousElementSibling && matches(tooltipEl.previousElementSibling, TRIGGER_SELECTOR))
                ? tooltipEl.previousElementSibling
                : null;
            if (relTrigger) relTrigger.classList.remove(OPEN_CLASS);
            closeTooltip(relTrigger, tooltipEl);
            $('.veil').hide();
            if (currentOpenTrigger === relTrigger) currentOpenTrigger = null; // ADDED
        }
    });
    // 🔴 ADDED START
   document.addEventListener('focusout', function (e) {

    setTimeout(function () {

        var activeEl = document.activeElement;

        var openTrigger =
            currentOpenTrigger ||
            document.querySelector(TRIGGER_SELECTOR + '.' + OPEN_CLASS);

        if (!openTrigger) return;

        var tooltip = getTooltipForTrigger(openTrigger);

        if (!tooltip) return;

        var focusInsideTrigger =
            openTrigger.contains(activeEl);

        var focusInsideTooltip =
            tooltip.contains(activeEl);

        if (!focusInsideTrigger && !focusInsideTooltip) {

            closeTooltip(openTrigger, tooltip);
            $('.veil').hide();

            if (currentOpenTrigger === openTrigger) {
                currentOpenTrigger = null;
            }
        }

    }, 0);

}, true);
    // 🔴 ADDED END
    // 🔴 ADDED START
   function hasInteractiveControls(container) {
    return !!container.querySelector(
        'button, a[href], input, select, textarea, not([tabindex="-1"])'
    );
}
    // 🔴 ADDED END

    // KEYDOWN: Enter toggles OPEN_CLASS; Escape removes it if present
    document.addEventListener('keydown', function (e) {
        // We only care about Enter and Escape
        if (e.key !== 'Enter' && e.key !== 'Escape' && e.key !== 'Esc') return;

        const active = document.activeElement;

        if (active && matches(active, TRIGGER_SELECTOR)) {
            const tooltip = getTooltipForTrigger(active);

            // ENTER: first press adds the class; second press removes it.
            if (e.key === 'Enter') {
                if (!isVisible(tooltip)) {
                    // First time: add class and open/show
                    // active.classList.add(OPEN_CLASS);
                    openTooltip(active, tooltip);
                    $('.veil').show();
                    currentOpenTrigger = active; // ADDED
                } else {
                    // Second time: remove class and close/hide
                    // active.classList.remove(OPEN_CLASS);
                    closeTooltip(active, tooltip);
                    $('.veil').hide();
                    if (currentOpenTrigger === active) currentOpenTrigger = null; // ADDED
                }
                return;
            }

            // ESC: only remove/close if currently active
            if (e.key === 'Escape' || e.key === 'Esc') {
                if (active.classList.contains(OPEN_CLASS)) {
                    active.classList.remove(OPEN_CLASS);
                    closeTooltip(active, tooltip);
                    $('.veil').hide();
                    if (currentOpenTrigger === active) currentOpenTrigger = null; // ADDED
                } else {
                    var openTriggerEl =
                        currentOpenTrigger ||
                        document.querySelector(TRIGGER_SELECTOR + '.' + OPEN_CLASS);

                    if (!openTriggerEl) {
                        var activeTooltip = closest(active, TOOLTIP_SELECTOR);
                        if (activeTooltip &&
                            activeTooltip.previousElementSibling &&
                            matches(activeTooltip.previousElementSibling, TRIGGER_SELECTOR)) {
                            openTriggerEl = activeTooltip.previousElementSibling;
                        }
                    }

                    if (openTriggerEl) {
                        var openTooltipEl = getTooltipForTrigger(openTriggerEl);
                        // openTriggerEl.classList.remove(OPEN_CLASS);
                        closeTooltip(openTriggerEl, openTooltipEl);
                        $('.veil').hide();
                        if (currentOpenTrigger === openTriggerEl) currentOpenTrigger = null; // ADDED
                    }
                }
            }
            return;
        }

        // ADDED: global Esc close when focus is NOT on the trigger
        if (e.key === 'Escape' || e.key === 'Esc') {
            var openTriggerEl =
                currentOpenTrigger ||
                document.querySelector(TRIGGER_SELECTOR + '.' + OPEN_CLASS);

            if (!openTriggerEl && active) {
                var activeTooltip = closest(active, TOOLTIP_SELECTOR);
                if (activeTooltip &&
                    activeTooltip.previousElementSibling &&
                    matches(activeTooltip.previousElementSibling, TRIGGER_SELECTOR)) {
                    openTriggerEl = activeTooltip.previousElementSibling;
                }
            }

            if (openTriggerEl) {
                var openTooltipEl = getTooltipForTrigger(openTriggerEl);
                openTriggerEl.classList.remove(OPEN_CLASS);
                closeTooltip(openTriggerEl, openTooltipEl);
                $('.veil').hide();
                if (currentOpenTrigger === openTriggerEl) currentOpenTrigger = null; // ADDED
            }
        }
    });

    var observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
            var m = mutations[i];
            var el = m.target;
            if (!(el && el.nodeType === 1)) continue; // Element nodes only

            if (matches(el, TOOLTIP_SELECTOR) || closest(el, TOOLTIP_SELECTOR)) {
                var tooltip = matches(el, TOOLTIP_SELECTOR) ? el : closest(el, TOOLTIP_SELECTOR);
                var trigger = (tooltip.previousElementSibling && matches(tooltip.previousElementSibling, TRIGGER_SELECTOR))
                    ? tooltip.previousElementSibling
                    : null;
                syncAria(trigger, tooltip);
            }

            if (matches(el, TRIGGER_SELECTOR) || closest(el, TRIGGER_SELECTOR)) {
                var trg = matches(el, TRIGGER_SELECTOR) ? el : closest(el, TRIGGER_SELECTOR);
                var tip = getTooltipForTrigger(trg);
                syncAria(trg, tip);
            }
        }
    });

    // observer.observe(document.documentElement, {
    //     attributes: true,
    //     attributeFilter: ['class', 'style', 'aria-hidden'],
    //     subtree: true
    // });

    // Initial sync in case some tooltips are already opened by server-side logic
    var triggers = document.querySelectorAll(TRIGGER_SELECTOR);
    for (var i = 0; i < triggers.length; i++) {
        var t = triggers[i];
        var tip = getTooltipForTrigger(t);
        restoreTooltipIcon(t);
        syncAria(t, tip);
    }

    // ---- Small helpers ----
    function closest(el, sel) {
        while (el && el.nodeType === 1) {
            if (matches(el, sel)) return el;
            el = el.parentElement;
        }
        return null;
    }
    // Watch for any script trying to hide the tooltip icon
    var iconObserver = new MutationObserver(function () {

        var icons = document.querySelectorAll('.tooltip-trigger .tooltip-icon');

        icons.forEach(function (icon) {

            var styles = window.getComputedStyle(icon);

            if (
                styles.display === 'none' ||
                styles.visibility === 'hidden' ||
                styles.opacity === '0'
            ) {
                icon.style.setProperty('display', 'block', 'important');
                icon.style.setProperty('visibility', 'visible', 'important');
                icon.style.setProperty('opacity', '1', 'important');
            }
        });
    });

    iconObserver.observe(document.body, {
        attributes: true,
        attributeFilter: ['style', 'class'],
        subtree: true
    });
})();
